import Cookies from './class/Cookies';

const COOKIEBAR_ID = 'cookie-bar';
const COOKIEBAR_BUTTON_ID = 'cookie-bar__consent-btn';
const COOKIEBAR_VISIBLE_CLASS = 'cookie-bar--visible';
const COOKIEBAR_HIDDEN_CLASS = 'cookie-bar--hidden';

let cookieBar;

function cookieConsent() {

    cookieBar = document.getElementById(COOKIEBAR_ID);

    if (cookieBar) {
        init();
    }

}

function init() {
    const cookieBarConsentBtn = document.getElementById(COOKIEBAR_BUTTON_ID);
    if (!Cookies.hasCookie('bundles-cookie-consent') && cookieBar) {
        cookieBar.classList.add(COOKIEBAR_VISIBLE_CLASS);
    }

    if (cookieBarConsentBtn) {
        cookieBarConsentBtn.addEventListener('click', (event) => {
            event.preventDefault();
            Cookies.setCookie('bundles-cookie-consent', 'true', 100);
            cookieBar.classList.remove(COOKIEBAR_VISIBLE_CLASS);
            cookieBar.classList.add(COOKIEBAR_HIDDEN_CLASS);
        });
    }
}

export default cookieConsent;